import { Icon } from '@iconify/react';
import RevealWrap from './RevealWrap';

const FAQS = [
  { q: '도입 비용은 얼마인가요?', a: '매장 상황에 따라 최적의 요금을 안내드리고 있습니다. 전화 한 통이면 정확한 견적을 바로 확인하실 수 있습니다. 치킨 1~2마리 수준의 가격에 놀라실 겁니다.' },
  { q: '기존 POS를 바꿔야 하나요?', a: '아닙니다. 현재 사용 중인 포스 시스템을 단 하나도 건드릴 필요 없이 그 위에 와우오더를 바로 얹으면 됩니다. 대부분의 주요 포스사와 연동 가능하며, 궁금하시면 1644-6827로 전화주시면 바로 확인해 드립니다.' },
  { q: '다른 테이블오더 서비스와 뭐가 다른가요?', a: '그 어떤 업체보다 강력한 네이버 카카오 리뷰 연동 시스템이 가장 큰 차별점입니다. 리뷰가 알아서 쌓이니 신규 손님이 자연스럽게 늘어납니다. 여기에 업계 최고 수준의 깔끔한 UI, 말도 안 되는 가격, 퀄리티 높은 QR판까지 직접 비교해 보시면 차이를 느끼실 겁니다.' },
  { q: '도입하면 매출이 실제로 올라가나요?', a: '네. 네이버 리뷰 유입으로 신규 손님 방문률이 크게 증가하고, QR 메뉴판의 사진과 추천 기능이 추가 주문을 유도합니다. 도입 매장 기준 매출 100~300% 상승, 테이블 회전율 156% 증가가 실측 데이터입니다.' },
  { q: '연세가 높은 고객도 사용할 수 있나요?', a: '코로나 이후 QR 사용이 일상화되면서, 이제는 연세가 높으신 분들도 QR 주문에 익숙하십니다. 오히려 사용을 못 하시는 분을 찾기가 어려울 정도입니다. 큰 글씨와 직관적인 UI로 누구나 쉽게 주문하실 수 있습니다.' },
  { q: '설치 기간은 얼마나 걸리나요?', a: '상담 후 2~3영업일 이내에 설치가 완료됩니다. 장비 설치부터 메뉴 등록, 직원 교육까지 원스톱으로 진행되어 사장님이 따로 하실 일이 없습니다.' },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-28 lg:py-40 bg-white relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <RevealWrap animation="scale" className="text-center mb-20">
          <p className="text-brand-600 font-semibold text-sm tracking-wide uppercase mb-3">FAQ</p>
          <h2 className="text-3xl lg:text-5xl font-bold leading-tight tracking-tight text-neutral-900 mb-4">
            자주 묻는 질문
          </h2>
          <p className="text-neutral-500 text-lg leading-relaxed max-w-md mx-auto">
            궁금하신 점이 있으시면 아래에서 확인해 보세요
          </p>
        </RevealWrap>

        <div className="grid md:grid-cols-2 gap-4">
          {FAQS.map((f, i) => (
            <RevealWrap key={f.q} animation="scale" className={`reveal-delay-${(i % 2) + 1}`}>
              <details className="group h-full">
                <summary className="flex items-start justify-between p-6 cursor-pointer list-none font-semibold text-neutral-900 hover:text-brand-600 transition-colors bg-neutral-50/80 border border-neutral-200/80 rounded-2xl group-open:rounded-b-none group-open:border-b-0 group-open:bg-neutral-50">
                  <span className="pr-4">{f.q}</span>
                  <div className="w-8 h-8 rounded-lg bg-neutral-100 group-hover:bg-brand-100 flex items-center justify-center flex-shrink-0 transition-colors duration-300">
                    <Icon
                      icon="solar:alt-arrow-down-linear"
                      className="text-lg text-neutral-400 transition-transform duration-500 group-open:rotate-180"
                    />
                  </div>
                </summary>
                <div className="px-6 pb-6 text-neutral-600 leading-relaxed bg-neutral-50 border border-neutral-200/80 border-t-0 rounded-b-2xl">
                  {f.a}
                </div>
              </details>
            </RevealWrap>
          ))}
        </div>
      </div>
    </section>
  );
}
